import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import globals from '../../../globals/communityGlobals';
import { nursing500 } from '../../../theme/AllocateColors';

const locale = globals.getArea('treatments');
const labelStyle = {
  textTransform: 'initial',
  color: nursing500,
};
class TreatmentInstanceDialogOpener extends React.Component {
  onClick = async () => {
    const { onOpen, show, id, getTreatmentData, treatmentId, treatmentInstanceId, occurrence } = this.props;
    onOpen(id);
    show(id);
    await getTreatmentData(treatmentId, treatmentInstanceId, occurrence);
  };

  render() {
    return (
      <FlatButton labelStyle={labelStyle} fullWidth label={locale.getMsg('treatmentDetails')} onClick={this.onClick} />
    );
  }
}

TreatmentInstanceDialogOpener.defaultProps = {
  onOpen: () => {},
};

TreatmentInstanceDialogOpener.propTypes = {
  id: PropTypes.string.isRequired,
  show: PropTypes.func.isRequired,
  treatmentId: PropTypes.number.isRequired,
  treatmentInstanceId: PropTypes.number.isRequired,
  occurrence: PropTypes.string.isRequired,
  getTreatmentData: PropTypes.func.isRequired,
  onOpen: PropTypes.func,
};

export default TreatmentInstanceDialogOpener;
